@if (mode === 'button') {
  <p-fileUpload [accept]="accept"
                [disabled]="disabled"
                [maxFileSize]="maxFileSize"
                [auto]="true"
                [multiple]="multiple"
                [chooseLabel]="label"
                class="p-fileupload-button"
                chooseIcon="icon-attachment">
  </p-fileUpload>
}

@if (mode === 'icon') {
  <p-fileUpload [accept]="accept"
                [disabled]="disabled"
                [maxFileSize]="maxFileSize"
                [auto]="true"
                [multiple]="multiple"
                class="p-fileupload-icon"
                [chooseIcon]="chooseIcon">
  </p-fileUpload>
}

@if (mode === 'dragdrop' && size === 'default') {
  @if (caption) {
    <div class="text-description c-primary-darken mb-10">{{ caption }}</div>
  }
  <p-fileUpload #pFileUpload
                [accept]="accept"
                [disabled]="disabled"
                [maxFileSize]="maxFileSize"
                [auto]="true"
                [multiple]="multiple"
                [class.uploading]="!this.isEmpty && !multiple"
                [class.dragging]="isDragging"
                class="p-fileupload-dragdrop">
    <ng-template pTemplate="toolbar">
      <div class="drop-area"
           (click)="pFileUpload.choose()"
           (dragover)="$event.preventDefault()"
           (dragenter)="ondragenter($event)"
           (dragleave)="ondragleave($event)"
           (drop)="ondrop($event)">
      </div>
      <div class="buttonbar-content">
        @if (isEmpty) {
          <i class="upload-icon icon-upload-cloud"></i>
          <div class="uploader-content-wrapper">
            <div>
              <div class="choose-label">{{ label }}</div>
              <div class="choose-description">[Choose a file or drag it here]</div>
              <div class="choose-allowed-types">Allowed types: {{ acceptLabel }}</div>
            </div>
          </div>
        } @else {
          @if (multiple) {
            <div class="carousel-container">
              <app-carousel [slides]="value">
                <ng-template let-file pTemplate="item">
                  <div class="slide">
                    <div class="slide-image">
                      <div class="w-100"></div>
                      <i class="icon icon-doc icon-l ic-primary "></i>
                      <button type="button" appStopPropagation class="btn delete icon-close ic-text"
                              (click)="delete(file)"></button>
                    </div>
                    <div class="slide-label fs-small text-truncated c-deep-blue">{{ file.originalName ?? file.name }}</div>
                    <div class="fs-small c-gray-secondary">{{ file.size | fileSizeConvert }}</div>
                  </div>
                </ng-template>
              </app-carousel>
            </div>
          } @else {
            <ng-container *ngTemplateOutlet="fileTemplate; context: { file: value }"></ng-container>
          }
        }
      </div>
    </ng-template>
  </p-fileUpload>
  @if (ngControl.dirty) {
    <app-validation-error [errors]="ngControl.errors"></app-validation-error>
  }
}

@if (mode === 'dragdrop' && size === 'small') {
  <p-fileUpload #pFileUpload
                [accept]="accept"
                [disabled]="disabled"
                [maxFileSize]="maxFileSize"
                [auto]="false"
                [showUploadButton]="false"
                [showCancelButton]="false"
                [multiple]="multiple"
                (onSelect)="onAdd()"
                class="p-fileupload-dropzone">
    <ng-template pTemplate="toolbar">
      <div class="dropzone-area"
           [class.bg-light]="!isDragging"
           [class.bg-primary-light]="isDragging"
           (click)="pFileUpload.choose()"
           (dragover)="$event.preventDefault()"
           (dragenter)="ondragenter($event)"
           (dragleave)="ondragleave($event)"
           (drop)="ondrop($event)">
        <i class="icon-upload ic-primary mr-10"></i>
        <span class="fs-small c-gray">{{ label }}</span>
      </div>
    </ng-template>
  </p-fileUpload>

  @for (msg of pFileUpload?.msgs; track msg) {
    <div class="fs-small c-error mt-10">{{ msg.text }}</div>
  }
}

<ng-template #fileTemplate let-file="file">
  <div>
    <button appStopPropagation class="btn icon-close ic-text delete" (click)="clear()"></button>
  </div>
  <div class="uploader-content-wrapper">
    <div>
      <div class="choose-label">{{ file.originalName }}</div>
      <div class="choose-description">{{ file.size | fileSizeConvert }}</div>
      @if (pFileUpload?.msgs?.length) {
        <div>
          @for (msg of pFileUpload.msgs; track msg) {
            <div class="error-message">
              {{ msg.summary }}
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
